/**
 * Filters out falsy values from an array and joins them with a space separator
 * @param parts - Array of strings to join
 * @returns Joined string with falsy values filtered out
 */
export const join = (parts: (string | null | undefined)[]): string => parts.filter(Boolean).join(" ")

// eslint-disable-next-line import/prefer-default-export
export { join as default }
